export const reloadsConstants = {
  RELOADS_OPERATORS_REQUEST: 'RELOADS_OPERATORS_REQUEST',
  RELOADS_OPERATORS_SUCCESS: 'RELOADS_OPERATORS_SUCCESS',

  RELOADS_PACKAGES_REQUEST: 'RELOADS_PACKAGES_REQUEST',
  RELOADS_PACKAGES_SUCCESS: 'RELOADS_PACKAGES_SUCCESS',
  RELOADS_PACKAGES_FAILURE: 'RELOADS_PACKAGES_FAILURE'
};
